<template>
    <div>
        <div class="d-flex justify-content-center mb-3">
            <ul class="nav nav-pills">
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="visao == 'prestadores' ? 'active' : ''" @click.prevent="selecionar('prestadores')">
                        Prestadores
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="visao == 'procedimentos' ? 'active' : ''" @click.prevent="selecionar('procedimentos')">
                        Procedimentos
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="visao == 'operadoras' ? 'active' : ''" @click.prevent="selecionar('operadoras')">
                        Operadoras
                    </a>
                </li>
                <li class="nav-item" v-if="1 == 0">
                    <a class="nav-link" href="#" :class="visao == 'teste' ? 'active' : ''" @click.prevent="selecionar('teste')">
                        Teste
                    </a>
                </li>
            </ul>
        </div>

        <!-- Prestadores -->

        <template v-if="visao == 'prestadores'">

            <az-empty-state v-if="!dados || !dados.medicos || !dados.medicos.length" />
            
            <table class="table table-sm bg-white table-hover cabecalho-fixo" v-else>
                <thead>
                    <tr>
                        <th width="30%">Nome</th>
                        <th>Especialidades</th>
                        <th>Operadoras</th>
                        <th>Procedimentos</th>
                        <th>Agendas</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(medico, idx) in dados.medicos" :key="idx">
                        <td>
                            <a href="#" class="card-link" @click.prevent="$util.abrirMedico(medico)">
                                {{ medico.st_nome_exibicao }}
                            </a>
                            <div class="small">
                                {{ medico.conselho ? medico.conselho.st_sigla : '' }}
                                {{ medico.in_numero_conselho }}-{{ medico.estado_conselho ? medico.estado_conselho.st_sigla : '' }}
                            </div>
                            <div class="small">
                                <span v-if="medico.medico_unidade.in_paciente_idade_minima || medico.medico_unidade.in_paciente_idade_maxima">
                                    Pacientes: 
                                    <span v-if="medico.medico_unidade.in_paciente_idade_minima && medico.medico_unidade.in_paciente_idade_maxima">
                                        {{ medico.medico_unidade.in_paciente_idade_minima }} a {{ medico.medico_unidade.in_paciente_idade_maxima }} anos
                                    </span>
                                    <span v-else-if="medico.medico_unidade.in_paciente_idade_minima">
                                        a partir de {{ medico.medico_unidade.in_paciente_idade_minima }} anos
                                    </span>
                                    <span v-else-if="medico.medico_unidade.in_paciente_idade_maxima">
                                        até {{ medico.medico_unidade.in_paciente_idade_maxima }} anos
                                    </span>
                                    <span v-if="medico.medico_unidade.ch_paciente_sexo" class="badge badge-secondary ml-1">
                                        {{ medico.medico_unidade.ch_paciente_sexo }}
                                    </span>
                                </span>
                            </div>
                        </td>
                        <td class="col col-12 col-md-3" :class="lista(medico.medico_especialidade, 'especialidade.search') ? '' : 'bg-warning'">
                            <small>
                                {{ lista(medico.medico_especialidade, 'especialidade.search') }}
                            </small>
                        </td>
                        <td :class="!medico.medico_operadora_count ? 'bg-warning' : ''">
                            {{ medico.medico_operadora_count }}
                        </td>
                        <td :class="!medico.medico_unidade.medico_procedimento_unidades_count ? 'bg-warning' : ''">
                            {{ medico.medico_unidade.medico_procedimento_unidades_count }}
                        </td>
                        <td v-if="medico.agendas.length">
                            <div class="small text-nowrap" v-for="(agenda, iax) in medico.agendas" :key="iax">
                                {{ agenda.search }}, {{ dia_da_semana(agenda.in_dia_semana) }}, {{ agenda.in_tempo_atendimento }}{{ agenda.fl_ordem_chegada ? ' vagas' : 'min' }}
                            </div>
                        </td>
                        <td v-else class="bg-warning">
                            &nbsp;
                        </td>
                    </tr>
                </tbody>
            </table>
        </template>

        <!-- Procedimentos -->
        <template v-if="visao == 'procedimentos'">
            <valid-procedimentos />
        </template>

        <!-- Operadoras -->
        <template v-if="visao == 'operadoras'">
            <valid-operadoras />
        </template>

        <!-- Teste -->
        <template v-if="visao == 'teste'">
            <side-bar />
        </template>

    </div>
</template>

<script>
import _ from 'lodash';
import AzEmptyState from '../../util/AzEmptyState.vue';
import ValidProcedimentos from './ValidProcedimentos.vue';
import ValidOperadoras from './ValidOperadoras.vue';
import SideBar from './SideBar.vue';

export default {
    data() { 
        return { 
            visao: 'prestadores',
            dados: {
                medicos: [], 
            }, 
        }
    },

    components: { 
        ValidProcedimentos, 
        ValidOperadoras, 
        AzEmptyState, 
        SideBar,
    },

    methods: { 
        selecionar (opcao) {  
            this.visao = opcao;
        },

        lista (items, campo) { 
            return items.map(item => _.get(item, campo))
                .join(', ');
        },

        load() { 

            let query = { q: [] };

            query.q.push({ name: "medicos.index", id: "medicos", parms: { validacao: true, ativos: true, sem_agenda_compartilhada: true } });
      
            this.axios
                .post("/aql?a=validgeral.index", query)
                .then(res => {
                    if ( !res.data )
                        return;

                    this.dados.medicos = res.data.medicos.data;

                });

        },

        dia_da_semana(dia) { 
            switch (dia) {
                case 0: return 'Dom';
                case 1: return 'Seg';
                case 2: return 'Ter';
                case 3: return 'Qua';
                case 4: return 'Qui';
                case 5: return 'Sex';
                case 6: return 'Sáb';
                default: return dia;
            }
        }
    },

    mounted() { 
        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Validação Geral", path: "/config/valid/geral" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.valid_permissao(this, 102, this.load);
    }
}
</script>